import { useSelector } from "react-redux";

import { useTemplateGroupActions } from "store/TemplateGroupSlice";

const useTemplateGroup = () => {
  const { loadTemplateGroup, loadTemplateGroupFromContentful, clearTemplateGroup } = useTemplateGroupActions();
  const { templateGroup } = useSelector((state) => state.TemplateGroupSlice);

  return {
    loadTemplateGroup,
    loadTemplateGroupFromContentful,
    clearTemplateGroup,
    templateGroup,
  };
};

export default useTemplateGroup;
